import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IparentTabState {
  parentTabId: string;
}

const initialState = {
  parentTabId: "",
};

const parentTabSlice = createSlice({
  name: "parentTab",
  initialState,
  reducers: {
    setParentTabId: (state, action: PayloadAction<string>) => {
      state.parentTabId = action.payload;
    },
  },
});

export const { setParentTabId } = parentTabSlice.actions;
export const selectParentTabId = (state: { parentTab: IparentTabState }) =>
  state.parentTab.parentTabId;
export const parentTabReducer = parentTabSlice.reducer;
